export default __webpack_public_path__ + "media/src/assets/images/EditIcon-9db0a4ae40f327dae9aee5691af3f963.svg";